module.exports = "<div class=\"pl-question__answer\">{{ ctrl.displayValue }}</div>\n";